/**
  系统公告路由配置
*/
// import InBoundBillBoard from '@/pages/InboundBillBoardHome';
// import InboundBillBoardDetail from '@/pages/InboundBillBoardDetail';
// import BookDetail from '@/pages/InboundBillBoardHome/DetailListCom/BookDetail';
// import UnmountedDetail from '@/pages/InboundBillBoardHome/DetailListCom/UnmountedDetail';
// import OutBoundBillBoard from '@/pages/OutboundBillBoardHome';
// import OutboundBillBoardDetail from '@/pages/OutboundBillBoardDetail';
// import Tetention from '@/pages/Tetention';
// import PeoplePortraits from '@/pages/PeoplePortraits';
// import AlgorithmList from '@/pages/AlgorithmList';
// import CentralData from '@/pages/CentralData';
import React from 'react';

export default [
  {
    path: '/service/inbound/billboard',
    // component: InBoundBillBoard,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'InBoundBillBoard' */ '@/pages/InboundBillBoardHome')),
  },
  {
    path: '/service/inbound/billboard/detail',
    // component: InboundBillBoardDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'InboundBillBoardDetail' */ '@/pages/InboundBillBoardDetail'),
    ),
  },
  {
    path: '/service/inbound/billboard/bookdetail',
    // component: BookDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BookDetail' */ '@/pages/InboundBillBoardHome/DetailListCom/BookDetail'),
    ),
  },
  {
    path: '/service/inbound/billboard/unmounteddetail',
    // component: UnmountedDetail,
    component: React.lazy(
      () =>
        import(/* webpackChunkName: 'UnmountedDetail' */ '@/pages/InboundBillBoardHome/DetailListCom/UnmountedDetail'),
    ),
  },
  {
    path: '/service/outbound/billboard',
    // component: OutBoundBillBoard,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'OutBoundBillBoard' */ '@/pages/OutboundBillBoardHome')),
  },
  {
    path: '/service/outbound/billboard/detail',
    // component: OutboundBillBoardDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'OutboundBillBoardDetail' */ '@/pages/OutboundBillBoardDetail'),
    ),
  },
  {
    path: '/service/Tetention/list',
    // component: Tetention,
    component: React.lazy(() => import(/* webpackChunkName: 'Tetention' */ '@/pages/Tetention')),
  },
  {
    path: '/service/PeoplePortraits',
    // component: PeoplePortraits,
    component: React.lazy(() => import(/* webpackChunkName: 'PeoplePortraits' */ '@/pages/PeoplePortraits')),
  },

  {
    path: '/service/algorithm/list',
    // component: AlgorithmList,
    component: React.lazy(() => import(/* webpackChunkName: 'AlgorithmList' */ '@/pages/AlgorithmList')),
  },

  {
    path: '/outbound/pick/central/data',
    // component: CentralData,
    component: React.lazy(() => import(/* webpackChunkName: 'CentralData' */ '@/pages/AutoWaveSummary')),
  },

  {
    path: '/service/personnel/operation',
    component: React.lazy(() => import(/* PersonnelOperationDetail */ '@/pages/PersonnelOperationDetail')),
  },
  {
    path: '/service/rowexportlist',
    component: React.lazy(() => import(/* rowexportlist */ '@/pages/rowexportlist')),
  },
  {
    path: '/service/fbireport',
    component: React.lazy(() => import(/* fbirepore */ '@/pages/fbirepore')),
  },
  {
    path: '/service/fbivaluereport',
    component: React.lazy(() => import(/* fbivaluereport */ '@/pages/fbivaluereport')),
  },
  {
    path: '/service/predictiverepore',
    component: React.lazy(() => import(/* predictiverepore */ '@/pages/PredictiveRepore')),
  },
  {
    path: '/service/outboundproduction',
    component: React.lazy(() => import(/* predictiverepore */ '@/pages/OutboundProduction')),
  },
  {
    path: '/service/inboundata/list',
    // component: Tetention,
    component: React.lazy(() => import(/* webpackChunkName: 'Tetention' */ '@/pages/InboundData')),
  },
  {
    path: '/service/workmonitor',
    component: React.lazy(() => import(/* webpackChunkName: 'Tetention' */ '@/pages/workmonitor')),
  },
  {
    path: '/service/measurementboard',
    component: React.lazy(() => import(/* webpackChunkName: 'measurementboard' */ '@/pages/MeasurementBoard')),
  },
  {
    path: '/service/CapacityHourBoard',
    component: React.lazy(() => import(/* CapacityHourBoard */ '@/pages/CapacityHourBoard')),
  },
];
